import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=2d5736e6&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "./courseList.vue?vue&type=style&index=0&id=2d5736e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5736e6",
  null
  
)

export default component.exports